export const hasResearchType = () => {
  let apiToken = localStorage.getItem('apiToken')
  let thesisResearcherType = localStorage.getItem('thesisResearcherType')

  if (
    (apiToken && !thesisResearcherType) ||
    thesisResearcherType == '' ||
    thesisResearcherType == 'null'
  ) {
    return false
  }

  return true
}

export const dateFormat = (date) => {
  if (!date) {
    return
  }

  const cleanedDate = date.replace(':AM', ' AM')
  const dateObj = new Date(cleanedDate)
  return dateObj.toISOString().split('T')[0]
}

export const dateTimeFormat = (defaultDate) => {
  if (!defaultDate) {
    return
  }

  const date = new Date(defaultDate)

  // Ambil dan format bagian-bagian tanggal
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0') // bulan mulai dari 0
  const yyyy = date.getFullYear()

  const hh = String(date.getHours()).padStart(2, '0')
  const min = String(date.getMinutes()).padStart(2, '0')
  const ss = '00' // karena input tidak menyertakan detik

  return `${dd}-${mm}-${yyyy} ${hh}:${min}`
}

export const timestampsFormat = (defaultDate) => {
  if (!defaultDate) {
    return
  }

  const date = new Date(defaultDate)

  // Ambil dan format bagian-bagian tanggal
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0') // bulan mulai dari 0
  const yyyy = date.getFullYear()

  const hh = String(date.getHours()).padStart(2, '0')
  const min = String(date.getMinutes()).padStart(2, '0')
  const ss = '00' // karena input tidak menyertakan detik

  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`
}

export const clearLocalStorageExcept = (keepKeys = []) => {
  // Daftar key yang ingin dipertahankan
  const defaultKeys = [
    'currentStep',
    'alumniPage',
    'ringkasan_proposal',
    'ringkasan_proposal_2',
    'judul_proposal',
    'judul_proposal_2',
  ]

  let defaultDataKeys = [...keepKeys, ...defaultKeys]

  // Simpan data yang ingin dipertahankan
  const savedData = {}

  defaultDataKeys.forEach((key) => {
    const value = localStorage.getItem(key)
    if (value !== null) {
      savedData[key] = value
    }
  })

  // Handle case where kt-auth-react-v might be empty or null
  const authData = localStorage.getItem('kt-auth-react-v')
  if (authData) {
    try {
      const lastLogin = JSON.parse(authData)
      if (lastLogin && lastLogin.users_id) {
        savedData['lastUserId'] = lastLogin.users_id
      }
    } catch (error) {
      console.warn('Failed to parse auth data:', error)
    }
  }

  // Hapus semua localStorage
  localStorage.clear()

  // Pulihkan data yang disimpan
  Object.keys(savedData).forEach((key) => {
    localStorage.setItem(key, savedData[key])
  })

}

export const isEmpty = (val) => {
  return val == null || val.trim?.() === ''
}

export const getGreeting = () => {
  const now = new Date()
  const hour = now.getHours()

  if (hour >= 4 && hour < 10) {
    return 'Selamat Pagi'
  } else if (hour >= 10 && hour < 15) {
    return 'Selamat Siang'
  } else if (hour >= 15 && hour < 18) {
    return 'Selamat Sore'
  } else {
    return 'Selamat Malam'
  }
}

export const scrollToElement = (errors, fieldRefs) => {
  const firstErrorField = Object.keys(errors)[0]
  const targetEl =
    (fieldRefs && fieldRefs[firstErrorField] && fieldRefs[firstErrorField].current) ||
    document.querySelector(`[name="${firstErrorField}"]`)

  if (!targetEl) return

  // cek apakah target ada di dalam modal yang terbuka
  const modalEl = targetEl.closest('.modal.show')

  // tentukan container scroll
  let container = window
  if (modalEl) {
    const bodyScrollable = modalEl.querySelector('.modal-dialog-scrollable .modal-body')
    container = bodyScrollable || modalEl
  }

  const offsetInside = -20
  const offsetWindow = -80

  requestAnimationFrame(() => {
    if (container === window) {
      const top = targetEl.getBoundingClientRect().top + window.pageYOffset + offsetWindow
      window.scrollTo({top, behavior: 'smooth'})
    } else {
      const c = container
      const top =
        targetEl.getBoundingClientRect().top -
        c.getBoundingClientRect().top +
        c.scrollTop +
        offsetInside
      c.scrollTo({top, behavior: 'smooth'})
    }

    if (targetEl.focus) {
      targetEl.focus({preventScroll: true})
    }
  })
}

export const toTitleCaseUnicode = (text) => {
  return text
    .toLocaleLowerCase()
    .replace(/(^|[\s\-\./,_])(\p{L})/gu, (_, sep, ch) => sep + ch.toLocaleUpperCase())
}

export const truncateText = (text, maxChars) => {
  if (!maxChars) return text
  const display =
    text.length <= maxChars
      ? text
      : (() => {
          const trimmed = text.slice(0, maxChars)
          const lastSpace = trimmed.lastIndexOf(' ')
          return (lastSpace > 0 ? trimmed.slice(0, lastSpace) : trimmed) + '...'
        })()

  return display
}

export const capitalizeWords = (str) =>
  str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
